import queryString from 'query-string';
import {
	// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
	createResource,
	type RouterContext,
	type RouterDataContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import type { Page, IssueTypeScheme } from './IssueTypeScheme.types.tsx';
import { getIssueTypeSchemes } from './getIssueTypeSchemes.tsx';

const ISSUE_TYPE_SCHEME_TABLE_TYPE = 'ISSUE_TYPE_SCHEME_TABLE';
const ISSUE_TYPE_SCHEME_TABLE_KEY = 'ISSUE_TYPE_SCHEME_TABLE_KEY';

const issueTypeSchemeResource: RouteResource<Page<IssueTypeScheme>> = createResource<
	Page<IssueTypeScheme>
>({
	type: ISSUE_TYPE_SCHEME_TABLE_TYPE,
	getKey: ({ query }: RouterContext) =>
		`${ISSUE_TYPE_SCHEME_TABLE_KEY}-${queryString.stringify(query)}`,
	maxAge: 0,
	getData: async ({ query }: RouterDataContext) =>
		getIssueTypeSchemes(queryString.stringify(query)),
});

export default issueTypeSchemeResource;
